import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import jsonData from "../src/components/ai-branding.json"; // Import the JSON file
import Header from "./components/Header";
import Body from "./components/Body/Body";
import Magic from "./components/Magic/Magic";
import Morganscan from "./components/Whysunwest/Morganscan";
import Morganlogo from "./components/Morganlogos/Morganlogos";
import axios from "axios";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";

const Footer = lazy(() => import("./components/Footerupdated/Footer.js"));
const Precapevent = lazy(() => import("./components/PrecapEvent/Preevent.js"));
const Market = lazy(() => import("./components/Market/Market.js"));
const Homebuyer = lazy(() => import("./components/Homebuyer/Homebuyer.js"));

// const PriorBroadcasts = lazy(() => import("./components/PriorBroadcasts/PriorBroadcasts"));

function App() {
  const isProduction = process.env.NODE_ENV === "production";
  const appVersion = appversion.version;
  // console.log(appVersion);
  // console.log(process.env.NODE_ENV);

  const [links, setLinks] = useState([]);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data.current);
      } catch (error) {
        console.error("Error fetching links:", error);
      }
    };
    fetchLinks();
  }, []);

  return (
    <CacheBuster
      Version={appversion.version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      {links ? (
        <>
      <div className="bodyContainer">
        <Header fetchpriority="high" links={links} />
          <Body links={links}/>
          <Suspense fallback={<div />}>
            <Homebuyer links={links}/>
          </Suspense>
          <Suspense fallback={<div />}>
            <Market links={links}/>
          </Suspense>
          <Suspense fallback={<div />}>
            <Precapevent links={links}/>
          </Suspense>
          <Magic links={links}/>
          <Morganlogo links={links}/>
          <Morganscan links={links}/>
          <Suspense fallback={<div />}>
            <Footer links={links}/>
          </Suspense>
      </div>
      </>
       ) : null}
    </CacheBuster>
  );
}

export default App;
